import { useContext } from "react";
import { EmbedContext } from "../context/EmbedContext";

export const useEmbed = () => {
  const context = useContext(EmbedContext);

  if (context === undefined) {
    throw new Error("useEmbed must be used within an EmbedProvider");
  }

  return context;
};
